export default __webpack_public_path__ + "static/media/login.2ad773e3.png";